<template>
    <div>
        <h3 class="title is-4">Union Information</h3>
        
        <div v-if="loading == true" class="notification is-warning">
            Loading ...
        </div>

        <div v-if="loading==false">
            

            <div class="field">
                <label class="label">Union Name</label>
                <div class="control">
                    <input class="input" type="text" v-model="member.union_name" required>
                </div>
            </div>

            <div class="field">
                <label class="label">Registration Number</label>
                <div class="control">
                    <input class="input" type="text" v-model="member.union_number" required>
                </div>
            </div>

            <div class="field">
                <label class="label">Date Recorded</label>
                <div class="control">
                    <input class="input" type="date" v-model="member.union_date_recorded" >
                </div>
            </div>

            
            <div class="field">
                <label class="label">Notes</label>
                <div class="control">
                    <textarea class="textarea" v-model="member.union_notes" ></textarea>
                </div>
            </div>

            <div class="field ">
                <div class="control">
                    <button class="button is-success" :disabled="working===true" @click="updateUnion()">Update Details</button>
                </div>
            </div>
           

           
        </div>
    </div>
</template>

<script>
import MemberMixin from '@/mixins/MemberMixin.js';

import MemberService from '@/services/MemberService.js';

export default {
    name: 'MemberUnion',
  data() {
    return {
      count: 0,
      loading: false,
      working: false
    }
  },
  mixins: [MemberMixin],
  props: ['member'],
  methods: {
        
        async updateUnion() {
			this.working = true
            var formdata = { 
                _method: 'patch',
                union_name: this.member.union_name,
                union_number: this.member.union_number,
                union_date_recorded: this.member.union_date_recorded,
                union_notes: this.member.union_notes
            }; 

            MemberService.updateMember(this.accessToken, formdata, this.member.id)
            .then((response) => {
                this.$emit('reload-member')
                console.log(response)
                
                }).catch((error) => {
                    if(error.response.status === 422)
                    {
                        console.log("Error:" + JSON.stringify(error.response.data));
                    }
                    alert("Something went wrong. Make sure you have filled in all the fields. \nOr ring David !!")
                    this.working = false
            });
        },
        
        
    },
    created() {
            this.getAccessToken()
            .then(() => { 
                
            });
        
        },
}
</script>